/**
 * @file pages/ForgotPassword.jsx
 * @description Forgot password page. Provides OTP-based password reset flow
 * with email input, OTP verification, and new password entry.
 */

import React, { useState } from 'react';
import { toast } from 'react-toastify';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [correctOtp, setCorrectOtp] = useState('');

  const handleSendOtp = () => {
    if (email) {
      const generatedOtp = Math.floor(100000 + Math.random() * 900000).toString();
      setCorrectOtp(generatedOtp);
      // In production, this should be sent via email service
      toast.success(`OTP sent to ${email}`);
      setOtpSent(true);
    } else {
      toast.error('Please enter a valid email.');
    }
  };

  const handleVerifyOtp = () => {
    if (otp === correctOtp) {
      toast.success('OTP verified! You can now reset your password.');
      // Here you would typically redirect to password reset form
    } else {
      toast.error('Incorrect OTP. Please try again.');
    }
  };

  return (
    <div className="h-screen flex items-center justify-center bg-gradient-to-r from-indigo-500 to-purple-600">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-sm">
        <h2 className="text-2xl font-bold mb-6 text-center">Forgot Password</h2>
        {!otpSent ? (
          <>
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full p-3 border rounded-lg mb-4"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button onClick={handleSendOtp} className="w-full bg-indigo-600 text-white p-3 rounded-lg">
              Send OTP
            </button>
          </>
        ) : (
          <>
            <input
              type="text"
              placeholder="Enter OTP"
              className="w-full p-3 border rounded-lg mb-4"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            <button onClick={handleVerifyOtp} className="w-full bg-indigo-600 text-white p-3 rounded-lg">
              Verify OTP
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;

